<template>
  <div class="panel news_list">
    <div class="panel_title">{{ title }}</div>
    <div class="panel_body">
      <el-empty v-if="!loading && isEmpty(industryList) && isEmpty(centralList)" />
      <ul v-loading="loading" v-else>
        <li
          v-for="item in centralList"
          class="news_list-item animate__fadeInLeft"
          :key="item.id"
          @click.stop="goPage(item.id, NEWS_TYPE[0].value)"
        >
          <div class="img">
            <img v-if="item.icon && item.icon[0]" :src="item.icon[0]" />
          </div>
          <div class="msg_box">
            <div class="row">
              <div class="left">{{ filterLabelValue(NEWS_TYPE, item.types) }}</div>
              <div class="time">{{ item.publishTime && item.publishTime.substring(0, 10) }}</div>
            </div>
            <div class="title ellipsis">{{ item.title }}</div>
          </div>
        </li>
        <li class="list news_list-item animate__fadeInRight">
          <div
            class="news_list-item animate__fadeInRight item"
            v-for="(item, i) in industryList"
            :style="{ 'animation-delay': i * 0.1 + 's' }"
            :key="item.id"
            @click.stop="goPage(item.id, NEWS_TYPE[1].value)"
          >
            <div class="title">{{ item.title }}</div>
            <div class="time">
              <i class="el-icon-time" />{{ item.publishTime && item.publishTime.substring(0, 10) }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getList } from "@/api/article";
import { NEWS_TYPE } from "@/dictionary";
import { isEmpty } from "@/utils/type";
import ListMixin from "@/mixins/ListMixin";
import { addWOW } from "@/utils";
import { filterLabelValue } from "@/filters/dictionaryFilters";

export default {
  name: "news_list",
  mixins: [ListMixin],
  data() {
    return {
      title: "新闻资讯",
      NEWS_TYPE,
      centralList: [],
      centralListLoading: false,
      industryList: [],
      industryListLoading: false,
      listParams: { publishStatus: "Published", module: "News" },
      autoLoad: false,
    };
  },
  computed: {
    loading: function () {
      return this.centralListLoading || this.industryListLoading;
    },
  },
  methods: {
    isEmpty,
    filterLabelValue,
    getDataList() {
      NEWS_TYPE.slice(0, 2).forEach(item => {
        const params = { ...this.listParams, types: item.value, size: 3, page: 1 };
        if (item.value == "1") {
          this.centralListLoading = true;
          params.size = 2;
        } else {
          this.industryListLoading = true;
        }
        getList(params)
          .then(res => {
            if (res?.data?.list) {
              let data = res.data;
              this._checkFileJson(data.list);
              if (item.value == "1") {
                this.centralList = data.list;
              } else {
                this.industryList = data.list;
              }
              this.$nextTick(() => {
                addWOW("news_list-item");
              });
            } else {
              if (item.value == "1") {
                this.centralList = [];
              } else {
                this.industryList = [];
              }
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            if (item.value == "1") {
              this.centralListLoading = false;
            } else {
              this.industryListLoading = false;
            }
          });
      });
    },
    goPage(id, val) {
      this.$router.push({
        path: "/exhibition-hall/news-information",
        query: { types: val, id },
      });
    },
  },
  created() {
    this.getDataList();
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
